export const MyDatetimeFormat = {
  parse: {
    dateInput: 'yyyy-LL-ddTHH:mm:ss',
  },
  display: {
    dateInput: 'dd/LL/yyyy HH:mm:ss',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  }
};
